import { createFileRoute } from '@tanstack/react-router';

type Search = {
  popout?: boolean;
  locationId: string;
  sessionId?: string;
};

/**
 * Route definition for wrapper library
 */
export const Route = createFileRoute('/weave-copilot')({
  validateSearch: (search: Search): Search => {
    return {
      popout: search.popout,
      locationId: search.locationId,
      sessionId: search.sessionId,
    };
  },
});
